"use strict";

import { campaignConstants } from "../_constants";

export const campaignGetLatestCampaignRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LATEST_CAMPAIGN_REQUEST,
        payload,
    };
};

export const campaignGetLatestCampaignComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LATEST_CAMPAIGN_COMPLETE,
        payload,
    };
};

export const getHomeCarouselCampaignRequest = (payload) => {
    return {
        type: campaignConstants.GET_HOME_CAROUSEL_CAMPAIGN_REQUEST,
        payload,
    };
};

export const getHomeCarouselCampaignComplete = (payload) => {
    return {
        type: campaignConstants.GET_HOME_CAROUSEL_CAMPAIGN_COMPLETE,
        payload,
    };
};

export const campaignHomeGetBestVoucherDealsTodayRequest = (payload) => {
    return {
        type: campaignConstants.GET_HOME_BEST_VOUCHER_DEALS_TODAY_REQUEST,
        payload,
    };
};

export const campaignHomeGetBestVoucherDealsTodayComplete = (payload) => {
    return {
        type: campaignConstants.GET_HOME_BEST_VOUCHER_DEALS_TODAY_COMPLETE,
        payload,
    };
};

export const campaignHomeGetTrendingVouchersRequest = (payload) => {
    return {
        type: campaignConstants.GET_HOME_TRENDING_VOUCHER_REQUEST,
        payload,
    };
};

export const campaignHomeGetTrendingVouchersComplete = (payload) => {
    return {
        type: campaignConstants.GET_HOME_TRENDING_VOUCHER_COMPLETE,
        payload,
    };
};

export const campaignGetFeaturedCampaignBannersRequest = (payload) => {
    return {
        type: campaignConstants.GET_FEATURED_CAMPAIGN_BANNERS_REQUEST,
        payload,
    };
};

export const campaignGetFeaturedCampaignBannersComplete = (payload) => {
    return {
        type: campaignConstants.GET_FEATURED_CAMPAIGN_BANNERS_COMPLETE,
        payload,
    };
};

export const campaignGetCampaignDetailsRequest = (payload) => {
    return {
        type: campaignConstants.GET_CAMPAIGN_DETAILS_REQUEST,
        payload,
    };
};

export const campaignGetCampaignDetailsComplete = (payload) => {
    return {
        type: campaignConstants.GET_CAMPAIGN_DETAILS_COMPLETE,
        payload,
    };
};

export const campaignTokenValidationRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SPINWIN_TOKEN_VALIDATION_REQUEST,
        payload,
    };
};

export const campaignTokenValidationComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SPINWIN_TOKEN_VALIDATION_COMPLETE,
        payload,
    };
};

export const campaignTokenValidationError = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SPINWIN_TOKEN_VALIDATION_ERROR,
        payload,
    };
};

export const campaignSpinwinGetDataRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SPINWIN_GET_DATA_REQUEST,
        payload,
    };
};

export const campaignSpinwinGetDataComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SPINWIN_GET_DATA_COMPLETE,
        payload,
    };
};

export const campaignSpinwinGetInitialDataRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SPINWIN_GET_INITIAL_DATA_REQUEST,
        payload,
    };
};

export const campaignSpinwinGetInitialDataComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SPINWIN_GET_INITIAL_DATA_COMPLETE,
        payload,
    };
};

export const joingIncentiveDataRequest = (payload) => {
    return {
        type: campaignConstants.JOING_INCENTIVE_DATA_REQUEST,
        payload,
    };
};

export const joingIncentiveDataComplete = (payload) => {
    return {
        type: campaignConstants.JOING_INCENTIVE_DATA_COMPLETE,
        payload,
    };
};

export const spinWheelTokenReset = () => {
    return {
        type: campaignConstants.SPINWHEEL_TOKEN_RESET,
    };
};

export const campaignHomeBannersRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_HOME_BANNERS_REQUEST,
        payload,
    };
};

export const campaignHomeBannersComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_HOME_BANNERS_COMPLETE,
        payload,
    };
};

export const campaignVoucherAddToFavouriteRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_VOUCHER_ADDTO_FAVOURITE_REQUEST,
        payload,
    };
};

export const campaignVoucherAddToFavouriteComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_VOUCHER_ADDTO_FAVOURITE_COMPLETE,
        payload,
    };
};

export const campaignVoucherRemoveFromFavouriteRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_VOUCHER_REMOVEFROM_FAVOURITE_REQUEST,
        payload,
    };
};

export const campaignVoucherRemoveFromFavouriteComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_VOUCHER_REMOVEFROM_FAVOURITE_COMPLETE,
        payload,
    };
};

export const getCampaignLeagueTableRequest = (payload) => {
    return {
        type: campaignConstants.GET_CAMPAIGN_LEAGUE_TABLE_REQUEST,
        payload,
    };
};

export const getCampaignLeagueTableComplete = (payload) => {
    return {
        type: campaignConstants.GET_CAMPAIGN_LEAGUE_TABLE_COMPLETE,
        payload,
    };
};

export const getParticipantSalesRequest = (payload) => {
    return {
        type: campaignConstants.GET_PARTICIPANT_SALES_REQUEST,
        payload,
    };
};

export const getParticipantSalesComplete = (payload) => {
    return {
        type: campaignConstants.GET_PARTICIPANT_SALES_COMPLETE,
        payload,
    };
};

export const campaignPrizeDrawDetailsRequest = (payload) => {
    return {
        type: campaignConstants.GET_CAMPAIGN_PRIZEDRAW_DETAILS_REQUEST,
        payload,
    };
};

export const campaignPrizeDrawDetailsComplete = (payload) => {
    return {
        type: campaignConstants.GET_CAMPAIGN_PRIZEDRAW_DETAILS_COMPLETE,
        payload,
    };
};

export const addPrizeDrawCampaignEntryRequest = (payload) => {
    return {
        type: campaignConstants.ADD_PRIZE_DRAW_CAMPAIGN_ENTRY_DATA_REQUEST,
        payload,
    };
};

export const addPrizeDrawCampaignEntryComplete = (payload) => {
    return {
        type: campaignConstants.ADD_PRIZE_DRAW_CAMPAIGN_ENTRY_DATA_COMPLETE,
        payload,
    };
};

export const getLeagueIndividualDetailsRequest = (payload) => {
    return {
        type: campaignConstants.GET_LEAGUE_INDIVIDUAL_DETAILS_DATA_REQUEST,
        payload,
    };
};

export const getLeagueIndividualDetailsComplete = (payload) => {
    return {
        type: campaignConstants.GET_LEAGUE_INDIVIDUAL_DETAILS_DATA_COMPLETE,
        payload,
    };
};

export const getLeagueTeamDetailsRequest = (payload) => {
    return {
        type: campaignConstants.GET_LEAGUE_TEAM_DETAILS_DATA_REQUEST,
        payload,
    };
};

export const getLeagueTeamDetailsComplete = (payload) => {
    return {
        type: campaignConstants.GET_LEAGUE_TEAM_DETAILS_DATA_COMPLETE,
        payload,
    };
};

export const submitLeagueTeamParticipantRequest = (payload) => {
    return {
        type: campaignConstants.SUBMIT_LEAGUE_TEAM_PARTICIPANT_REQUEST,
        payload,
    };
};

export const submitLeagueTeamParticipantComplete = (payload) => {
    return {
        type: campaignConstants.SUBMIT_LEAGUE_TEAM_PARTICIPANT_COMPLETE,
        payload,
    };
};

export const getCommsDetailsRequest = (payload) => {
    return {
        type: campaignConstants.GET_COMMS_DETAILS_REQUEST,
        payload,
    };
};

export const getCommsDetailsComplete = (payload) => {
    return {
        type: campaignConstants.GET_COMMS_DETAILS_COMPLETE,
        payload,
    };
};

export const campaignGetWareAndTireSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_WARE_AND_TIRE_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetWareAndTireSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_WARE_AND_TIRE_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetLeagueTableSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetLeagueTableSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetLeagueTableSummaryDropDownRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_DROP_DOWN_REQUEST,
        payload,
    };
};

export const campaignGetLeagueTableSummaryDropDownComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_DROP_DOWN_COMPLETE,
        payload,
    };
};

export const campaignGetParticipantIncentiveRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_PARTICIPANT_ACTIVE_CAMPAIGNS_REQUEST,
        payload,
    };
};

export const campaignGetParticipantIncentiveComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_PARTICIPANT_ACTIVE_CAMPAIGNS_COMPLETE,
        payload,
    };
};

export const campaignGetParticipantIncentiveCampaignPerformanceMetricsRequest =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_PARTICIPANT_INCENTIVE_PERFORMANCE_METRICS_REQUEST,
            payload,
        };
    };

export const campaignGetParticipantIncentiveCampaignPerformanceMetricsComplete =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_PARTICIPANT_INCENTIVE_PERFORMANCE_METRICS_COMPLETE,
            payload,
        };
    };

export const campaignParticipantIncentiveCampaignPerformanceMetricsClear =
    () => {
        return {
            type: campaignConstants.CAMPAIGN_PARTICIPANT_INCENTIVE_PERFORMANCE_METRICS_CLEAR,
        };
    };

export const campaignParticipantIncentiveClear = () => {
    return {
        type: campaignConstants.CAMPAIGN_PARTICIPANT_ACTIVE_CAMPAIGNS_CLEAR,
    };
};

export const campaignGetCastrolLeagueTableSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetCastrolLeagueTableSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignPageLogPageViewRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_PAGE_LOG_PAGE_VIEW_REQUEST,
        payload,
    };
};

export const campaignPageLogPageViewComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_PAGE_LOG_PAGE_VIEW_COMPLETE,
        payload,
    };
};

export const campaignLikeContentPageRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_PAGE_LIKE_CONTENT_REQUEST,
        payload,
    };
};

export const campaignLikeContentPageComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_PAGE_LIKE_CONTENT_COMPLETE,
        payload,
    };
};

export const campaignLikeSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_PAGE_LIKE_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignLikeSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_PAGE_LIKE_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetAreaManagerDealersRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_AREA_MANAGERS_DEALERS_REQUEST,
        payload,
    };
};

export const campaignGetAreaManagerDealersComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_AREA_MANAGERS_DEALERS_COMPLETE,
        payload,
    };
};

export const campaignGetOverdriveDealersRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_OVERDRIVE_DEALERS_REQUEST,
        payload,
    };
};

export const campaignGetOverdriveDealersComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_OVERDRIVE_DEALERS_COMPLETE,
        payload,
    };
};

export const campaignGetParticipantsByDealerRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_PARTICIPANTS_BY_DEALERS_REQUEST,
        payload,
    };
};

export const campaignGetParticipantsByDealerComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_PARTICIPANTS_BY_DEALERS_COMPLETE,
        payload,
    };
};

export const campaignGetPerformanceMetricsByDealerRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_REQUEST,
        payload,
    };
};

export const campaignGetPerformanceMetricsByDealerComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_COMPLETE,
        payload,
    };
};

export const campaignGetPerformanceMetricsByDealerDropDownRequest = (
    payload,
) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_DROP_DOWN_REQUEST,
        payload,
    };
};

export const campaignGetPerformanceMetricsByDealerDropDownComplete = (
    payload,
) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_DROP_DOWN_COMPLETE,
        payload,
    };
};

export const campaignGetAreaManagersLeaguesRankSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_AREA_MANAGER_LEAGUES_RANK_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetAreaManagersLeaguesRankSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_AREA_MANAGER_LEAGUES_RANK_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetCastrolLeagueQ4TableSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_Q4_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetCastrolLeagueQ4TableSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_Q4_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetServiceManagersLeaguesBonusRankBatterySummaryRequest = (
    payload,
) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetServiceManagersLeaguesBonusRankBatterySummaryComplete =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_COMPLETE,
            payload,
        };
    };

export const campaignGetServiceManagersLeaguesBonusRankBatterySummaryDropDownRequest =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_DROP_DOWN_REQUEST,
            payload,
        };
    };

export const campaignGetServiceManagersLeaguesBonusRankBatterySummaryDropDownComplete =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_DROP_DOWN_COMPLETE,
            payload,
        };
    };

export const campaignGetServiceManagersLeaguesBonusRankBrakePadsSummaryRequest =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_PADS_SUMMARY_REQUEST,
            payload,
        };
    };

export const campaignGetServiceManagersLeaguesBonusRankBrakePadsSummaryComplete =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_PADS_SUMMARY_COMPLETE,
            payload,
        };
    };

export const campaignGetServiceManagersLeaguesBonusRankWiperBladeSummaryRequest =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_WIPER_BLADE_SUMMARY_REQUEST,
            payload,
        };
    };

export const campaignGetServiceManagersLeaguesBonusRankWiperBladeSummaryComplete =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_WIPER_BLADE_SUMMARY_COMPLETE,
            payload,
        };
    };

export const campaignGetServiceManagersLeaguesBonusRankBrakeDiscsSummaryRequest =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_DISCS_SUMMARY_REQUEST,
            payload,
        };
    };

export const campaignGetServiceManagersLeaguesBonusRankBrakeDiscsSummaryComplete =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_DISCS_SUMMARY_COMPLETE,
            payload,
        };
    };

export const campaignGetServiceManagersLeaguesBonusRankAreaTopPerformerSummaryRequest =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_AREA_TOP_SUMMARY_REQUEST,
            payload,
        };
    };

export const campaignGetServiceManagersLeaguesBonusRankAreaTopPerformerSummaryComplete =
    (payload) => {
        return {
            type: campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_AREA_TOP_SUMMARY_COMPLETE,
            payload,
        };
    };

export const campaignGetLeagueNationalTopPerformerSummaryRequest = (
    payload,
) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetLeagueNationalTopPerformerSummaryComplete = (
    payload,
) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetLeagueNationalTopPerformerSummaryDropDownRequest = (
    payload,
) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_DROP_DOWN_REQUEST,
        payload,
    };
};

export const campaignGetLeagueNationalTopPerformerSummaryDropDownComplete = (
    payload,
) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_DROP_DOWN_COMPLETE,
        payload,
    };
};

export const getTlcCustomerRequest = (payload) => {
    return {
        type: campaignConstants.GET_TLC_CUSTOMER_REQUEST,
        payload,
    };
};

export const getTlcCustomerComplete = (payload) => {
    return {
        type: campaignConstants.GET_TLC_CUSTOMER_COMPLETE,
        payload,
    };
};

export const getGoldRushCampaignPerformanceSummaryRequest = (payload) => {
    return {
        type: campaignConstants.GET_GOLD_RUSH_CAMPAIGN_PERFORMANCE_SUMMARY_REQUEST,
        payload,
    };
};

export const getGoldRushCampaignPerformanceSummaryComplete = (payload) => {
    return {
        type: campaignConstants.GET_GOLD_RUSH_CAMPAIGN_PERFORMANCE_SUMMARY_COMPLETE,
        payload,
    };
};

export const getCastrolDealerPerformanceSummaryRequest = (payload) => {
    return {
        type: campaignConstants.GET_CASTROL_DEALER_PERFORMANCE_SUMMARY_REQUEST,
        payload,
    };
};

export const getCastrolDealerPerformanceSummaryComplete = (payload) => {
    return {
        type: campaignConstants.GET_CASTROL_DEALER_PERFORMANCE_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetTlcRetailersRequest = (payload) => {
    return {
        type: campaignConstants.TLC_GET_TLC_RETAILERS_REQUEST,
        payload,
    };
};

export const campaignGetTlcRetailersComplete = (payload) => {
    return {
        type: campaignConstants.TLC_GET_TLC_RETAILERS_COMPLETE,
        payload,
    };
};

export const campaignGetServiceStartLeagueRankSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SERVICE_STAR_GET_SERVICE_STAR_LEAGUE_RANK_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetServiceStartLeagueRankSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SERVICE_STAR_GET_SERVICE_STAR_LEAGUE_RANK_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetWearAndTearTeamPerformanceSummaryRequest = (
    payload,
) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_WEAR_AND_TEAR_TEAM_PERFORMANCE_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetWearAndTearTeamPerformanceSummaryComplete = (
    payload,
) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_WEAR_AND_TEAR_TEAM_PERFORMANCE_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetWinningSpinDataRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_WINNING_SPIN_DATA_REQUEST,
        payload,
    };
};

export const campaignGetWinningSpinDataComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_WINNING_SPIN_DATA_COMPLETE,
        payload,
    };
};

export const campaignGetLcvRegistrationTrackerRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LCV_REGISTRATION_TRACKER_REQUEST,
        payload,
    };
};

export const campaignGetLcvRegistrationTrackerComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LCV_REGISTRATION_TRACKER_COMPLETE,
        payload,
    };
};

export const campaignGetLcvWinningSpinsRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LCV_WINNING_SPINS_REQUEST,
        payload,
    };
};

export const campaignGetLcvWinningSpinsComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LCV_WINNING_SPINS_COMPLETE,
        payload,
    };
};

export const campaignGetLcvWinningSpinsError = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LCV_WINNING_SPINS_ERROR,
        payload,
    };
};

export const campaignGetAlpineRewardSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_ALPINE_REWARD_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetAlpineRewardSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_ALPINE_REWARD_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetTradePartsManagerSalesSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_TRADE_PARTS_MANAGER_INCENTIVE_REQUEST,
        payload,
    };
};

export const campaignGetTradePartsManagerSalesSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_TRADE_PARTS_MANAGER_INCENTIVE_COMPLETE,
        payload,
    };
};

export const campaignGetCastrolMotoLeaguesRankSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CASTROL_MOTO_GP_LEAGUES_RANK_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetCastrolMotoLeaguesRankSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CASTROL_MOTO_GP_LEAGUES_RANK_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetTLCCustomerByDealersRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_TLC_CUSTOMER_BY_DEALERS_REQUEST,
        payload,
    };
};

export const campaignGetTLCCustomerByDealersComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_TLC_CUSTOMER_BY_DEALERS_COMPLETE,
        payload,
    };
};

export const campaignGetFullThrottleLeagueRankSummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_FULL_THROTTLE_LEAGUE_RANK_SUMMARY_REQUEST,
        payload,
    };
};

export const campaignGetFullThrottleLeagueRankSummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_FULL_THROTTLE_LEAGUE_RANK_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGoldenTicketScratchCardDataRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GOLDEN_TICKET_SCRATCH_CARD_DATA_REQUEST,
        payload,
    };
};

export const campaignGoldenTicketScratchCardDataComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GOLDEN_TICKET_SCRATCH_CARD_DATA_COMPLETE,
        payload,
    };
};

export const campaignGoldenTicketClaimScratchCardCodeRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GOLDEN_TICKET_CLAIM_SCRATCH_CARD_CODE_REQUEST,
        payload,
    };
};

export const campaignGoldenTicketClaimScratchCardCodeComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GOLDEN_TICKET_CLAIM_SCRATCH_CARD_CODE_COMPLETE,
        payload,
    };
};

export const campaignClaimLiquidGoldScratchCodeRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_CLAIM_LIQUID_GOLD_SCRATCH_CODE_REQUEST,
        payload,
    };
};

export const campaignClaimLiquidGoldScratchCodeComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_CLAIM_LIQUID_GOLD_SCRATCH_CODE_COMPLETE,
        payload,
    };
};

export const campaignVoteRewardPreferencesRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_VOTE_REWARD_PREFERENCES_REQUEST,
        payload,
    };
};

export const campaignVoteRewardPreferencesComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_VOTE_REWARD_PREFERENCES_COMPLETE,
        payload,
    };
};

export const campaignVChangeRole = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_CHANGE_ROLE,
        payload,
    };
};
export const campaignGetAllAreaManagerDealersRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_ALL_AREA_MANAGERS_DEALERS_REQUEST,
        payload,
    };
};
export const campaignGetAllAreaManagerDealersComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_ALL_AREA_MANAGERS_DEALERS_COMPLETE,
        payload,
    };
};

export const campaignGetCastrol500CampaignDataRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CASTROL500_CAMPAIGN_REQUEST,
        payload,
    };
};
export const campaignGetCastrol500CampaignDataComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CASTROL500_CAMPAIGN_COMPLETE,
        payload,
    };
};

export const campaignGetEarnBigBrakePadsCampaignDataRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_EARN_BIG_BRAKE_CAMPAIGN_REQUEST,
        payload,
    };
};
export const campaignGetEarnBigBrakePadsCampaignDataComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_EARN_BIG_BRAKE_CAMPAIGN_COMPLETE,
        payload,
    };
};

export const campaignGetGetCuttingEdgeQ3CampaignDataRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CUTTING_EDGE_Q3_CAMPAIGN_DATA_REQUEST,
        payload,
    };
};
export const campaignGetGetCuttingEdgeQ3CampaignDataComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CUTTING_EDGE_Q3_CAMPAIGN_DATA_COMPLETE,
        payload,
    };
};
export const campaignGetGetCuttingEdgeQ4CampaignDataRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CUTTING_EDGE_Q4_CAMPAIGN_DATA_REQUEST,
        payload,
    };
};
export const campaignGetGetCuttingEdgeQ4CampaignDataComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CUTTING_EDGE_Q4_CAMPAIGN_DATA_COMPLETE,
        payload,
    };
};

export const campaignGetFullThrottleLeagueRankQ3SummaryRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_FULL_THROTTLE_LEAGUE_RANK_Q3_SUMMARY_REQUEST,
        payload,
    };
};
export const campaignGetFullThrottleLeagueRankQ3SummaryComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_FULL_THROTTLE_LEAGUE_RANK_Q3_SUMMARY_COMPLETE,
        payload,
    };
};

export const campaignGetDealerEhcvFocusCampaignDataRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_DEALER_EHCV_FOCUS_CAMPAIGN_DATA_REQUEST,
        payload,
    };
};
export const campaignGetDealerEhcvFocusCampaignDataComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_DEALER_EHCV_FOCUS_CAMPAIGN_DATA_COMPLETE,
        payload,
    };
};

export const campaignGetServiceStar2026CampaignDataRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_SERVICE_STAR_2026_CAMPAIGN_DATA_REQUEST,
        payload,
    };
};
export const campaignGetServiceStar2026CampaignDataComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_SERVICE_STAR_2026_CAMPAIGN_DATA_COMPLETE,
        payload,
    };
};

export const campaignGetIcrmCampaignDataRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_ICRM_CAMPAIGN_DATA_REQUEST,
        payload,
    };
};
export const campaignGetIcrmCampaignDataComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_ICRM_CAMPAIGN_DATA_COMPLETE,
        payload,
    };
};

export const campaignGetCuttingEdgeCampaignDataRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CUTTING_EDGE_CAMPAIGN_DATA_REQUEST,
        payload,
    };
};
export const campaignGetCuttingEdgeCampaignDataComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CUTTING_EDGE_CAMPAIGN_DATA_COMPLETE,
        payload,
    };
};

export const campaignSearchCustomersRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SEARCH_CUSTOMERS_REQUEST,
        payload,
    };
};

export const campaignSearchCustomersComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SEARCH_CUSTOMERS_COMPLETE,
        payload,
    };
};

export const campaignGetMotrioTradeTargetsRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_MOTRIO_TRADE_TARGETS_REQUEST,
        payload,
    };
};

export const campaignGetMotrioTradeTargetsComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_MOTRIO_TRADE_TARGETS_COMPLETE,
        payload,
    };
};

export const campaignGetCustomerAccountStatusRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CUSTOMER_ACCOUNT_STATUS_REQUEST,
        payload,
    };
};

export const campaignGetCustomerAccountStatusComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CUSTOMER_ACCOUNT_STATUS_COMPLETE,
        payload,
    };
};

export const campaignGetRgRewardsTargetsRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_RG_REWARDS_TARGETS_REQUEST,
        payload,
    };
};

export const campaignGetRgRewardsTargetsComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_RG_REWARDS_TARGETS_COMPLETE,
        payload,
    };
};

export const campaignGetRgRewardsTargetsByCustomerRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_RG_REWARDS_TARGETS_BY_CUSTOMER_REQUEST,
        payload,
    };
};

export const campaignGetRgRewardsTargetsByCustomerComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_RG_REWARDS_TARGETS_BY_CUSTOMER_COMPLETE,
        payload,
    };
};

export const campaignSendActivationEmailRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SEND_ACTIVATION_EMAIL_REQUEST,
        payload,
    };
};

export const campaignSendActivationEmailComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_SEND_ACTIVATION_EMAIL_COMPLETE,
        payload,
    };
};

export const campaignGetMotrioRewardsByCustomerRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_MOTRIO_REWARDS_BY_CUSTOMER_REQUEST,
        payload,
    };
};

export const campaignGetMotrioRewardsByCustomerComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_MOTRIO_REWARDS_BY_CUSTOMER_COMPLETE,
        payload,
    };
};

export const campaignGetMotrioPaydaysWinnersRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_MOTRIO_PAYDAYS_WINNERS_REQUEST,
        payload,
    };
};

export const campaignGetMotrioPaydaysWinnersComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_MOTRIO_PAYDAYS_WINNERS_COMPLETE,
        payload,
    };
};

export const campaignGetCastrolLegendsCampaignDataRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CASTROL_LEGENDS_CAMPAIGN_DATA_REQUEST,
        payload,
    };
};

export const campaignGetCastrolLegendsCampaignDataComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CASTROL_LEGENDS_CAMPAIGN_DATA_COMPLETE,
        payload,
    };
};

export const campaignGetCastrolLegendsCampaignPerformanceDataRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CASTROL_LEGENDS_CAMPAIGN_PERFORMANCE_DATA_REQUEST,
        payload,
    };
};

export const campaignGetCastrolLegendsCampaignPerformanceDataComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_CASTROL_LEGENDS_CAMPAIGN_PERFORMANCE_DATA_COMPLETE,
        payload,
    };
};

export const campaignGetLiquidGoldCampaignInfoRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LIQUID_GOLD_CAMPAIGN_INFO_REQUEST,
        payload,
    };
};

export const campaignGetLiquidGoldCampaignInfoComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_LIQUID_GOLD_CAMPAIGN_INFO_COMPLETE,
        payload,
    };
};

export const campaignValidateLiquidGoldScratchCodeRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_LIQUID_GOLD_SCRATCH_CODE_VALIDATION_REQUEST,
        payload,
    };
};

export const campaignValidateLiquidGoldScratchCodeComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_LIQUID_GOLD_SCRATCH_CODE_VALIDATION_COMPLETE,
        payload,
    };
};

export const campaignValidateLiquidGoldScratchCodeError = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_LIQUID_GOLD_SCRATCH_CODE_VALIDATION_ERROR,
        payload,
    };
};

export const campaignValidateLiquidGoldScratchCodeReset = () => {
    return {
        type: campaignConstants.CAMPAIGN_LIQUID_GOLD_SCRATCH_CODE_VALIDATION_RESET,
    };
};

export const campaignGetOverDriveCampaignDataRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_OVER_DRIVEN_CAMPAIGN_DATA_REQUEST,
        payload,
    };
};

export const campaignGetOverDriveCampaignDataComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_OVER_DRIVEN_CAMPAIGN_DATA_COMPLETE,
        payload,
    };
};


export const campaignGetOptimumFrictionCampaignInfoRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_OPTIMUM_FRICTION_CAMPAIGN_INFO_REQUEST,
        payload,
    };
};

export const campaignGetOptimumFrictionCampaignInfoComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_OPTIMUM_FRICTION_CAMPAIGN_INFO_COMPLETE,
        payload,
    };
};

export const campaignGetOptimumFrictionCardsRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_OPTIMUM_FRICTION_CARDS_REQUEST,
        payload,
    };
};

export const campaignGetOptimumFrictionCardsComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_OPTIMUM_FRICTION_CARDS_COMPLETE,
        payload,
    };
};

export const campaignGetOptimumFrictionWinnersRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_OPTIMUM_FRICTION_WINNERS_REQUEST,
        payload,
    };
};

export const campaignGetOptimumFrictionWinnersComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_GET_OPTIMUM_FRICTION_WINNERS_COMPLETE,
        payload,
    };
};

export const campaignPlayOptimumFrictionCardRequest = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_PLAY_OPTIMUM_FRICTION_CARD_REQUEST,
        payload,
    };
};

export const campaignPlayOptimumFrictionCardComplete = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_PLAY_OPTIMUM_FRICTION_CARD_COMPLETE,
        payload,
    };
};

export const campaignPlayOptimumFrictionCardError = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_PLAY_OPTIMUM_FRICTION_CARD_ERROR,
        payload,
    };
};

export const campaignPlayOptimumFrictionCardReset = (payload) => {
    return {
        type: campaignConstants.CAMPAIGN_PLAY_OPTIMUM_FRICTION_CARD_RESET,
        payload,
    };
};
